import styled from 'styled-components'
import PropTypes from 'prop-types'

import colors from 'components/utils/colors'

import IconLink from 'components/Shared/IconLink/Index'
import Badge from 'components/Shared/Badge/Index'

const StyledWrapper = styled.div`
  padding-top: 26px;
  max-width: 1112px;
`

const StyledHeader = styled.div`
  text-transform: none;
  font-family: Exo;
  font-size: 20px;
  display: flex;
  align-items: center;
  color: ${colors.secondary20};
  margin-bottom: 14px;
`

const StyledBadge = styled(Badge)`
  margin 0 1px 0 8px;
  color: ${colors.secondary20};
`

const StyledCollapseLink = styled(IconLink)`
  margin: 0 40px 0 5px;
`

const StyledContent = styled.div`
  position: relative; /* for loading indicator */
`


const ExpandablePageSection = ({
  id, title, badgeText, isExpanded, onToggleExpanded, headerLink, children, dataTest,
}) => {
  const expandIcon = isExpanded ? 'icon-arrow-down' : 'icon-arrow-right'

  return (
    <StyledWrapper id={id} data-test={dataTest}>
      <StyledHeader data-test='expandable-section-header'>
        {title}
        <StyledBadge color={colors.success90}>{badgeText}</StyledBadge>

        <StyledCollapseLink
          onClick={onToggleExpanded}
          iconName={expandIcon}
        />

        {headerLink}
      </StyledHeader>

      {!!isExpanded && <StyledContent>{children}</StyledContent>}
    </StyledWrapper>
  )
}

ExpandablePageSection.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string.isRequired,
  badgeText: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  isExpanded: PropTypes.bool,
  onToggleExpanded: PropTypes.func.isRequired,
  headerLink: PropTypes.node,
  children: PropTypes.node,
  dataTest: PropTypes.string,
}

export default ExpandablePageSection
